import pdfIcon from "./../../../../assets/images/pdf.png"; // Adjust the path as necessary

function ShipRegistryOffencesTab() {
const documents = [
      {
        title: "CARGO AND TOWAGE APPROVAL",
        modified: "2019/08/05  10.35 AM",
        items: [
          "Notification_of_intention_to_build_0.",
          "INNotification_of_intention_to_build_0.",
        ],
      },
      {
        title: "Casualty Report",
        modified: "2019/08/05  10.35 AM",
        items: [
          "INS-701-08-01 IMDG Explosive Area Inspection - Class 1",
          "INS-701-08-03 Container Inspection Form",
          "INS-701-09-01 Towage Inspection",
        ],
      },
    ];


  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        SHIP REGISTRY
        <span className="text-orange-ef3e33 font-400"> offences </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div class="col-12">
          <p class="mb-3 text-primary-color font-700">SUMMARY OF OFFENCES AGAINS THE SHIP REGISTRATION ACT​</p>
          <p class="text-primary-color">Note: Offences by body corporate. Section 52(5) of the Act provides that  where a body corporate is guilty of an offence, a director, manager,  secretary or other officer of the body corporate who is in any way, by  act or omission, directly or indirectly, knowingly concerned in or party to the offence is also guilty of that offence and is punishable  accordingly. This applies to all offences in terms of the Act, including those offences established by the regulations.</p>
        </div>
        <div className="col-12">
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="true"
                  aria-controls="blackTabOne"
                >
                  Failing to hoist the National Flag on South African Ship
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <p className="mb-3">
                        <b className="d-block">​Description of offence</b>
                        Failing to hoist the National Flag on South African Ship
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Section / Item</b>
                        4(2) read with 52(1) & (2)
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Person(s) liable</b>
                        Master
                      </p>

                      <p className="">
                        <b className="d-block">Penalty</b>
                        R40 000 or 2 years
                      </p>

                      
                    </div>

                 
                  </div>
                  
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="false"
                  aria-controls="blackTabTwo"
                >
                  Check Sheets​
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                        <b className="d-block">​Description of offence</b>
                        Failing to hoist the National Flag on South African Ship
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Section / Item</b>
                        4(2) read with 52(1) & (2)
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Person(s) liable</b>
                        Master
                      </p>

                      <p className="">
                        <b className="d-block">Penalty</b>
                        R40 000 or 2 years
                      </p>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >
                  Permitting prohibited colours etc to be hoisted on a South African Ship
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                        <b className="d-block">​Description of offence</b>
                        Failing to hoist the National Flag on South African Ship
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Section / Item</b>
                        4(2) read with 52(1) & (2)
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Person(s) liable</b>
                        Master
                      </p>

                      <p className="">
                        <b className="d-block">Penalty</b>
                        R40 000 or 2 years
                      </p>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabFour"
                  aria-expanded="false"
                  aria-controls="blackTabFour"
                >
                  Unlawfully causing ship to appear to be a South African ship.
                </button>
              </h2>
              <div
                id="blackTabFour"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                        <b className="d-block">​Description of offence</b>
                        Failing to hoist the National Flag on South African Ship
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Section / Item</b>
                        4(2) read with 52(1) & (2)
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Person(s) liable</b>
                        Master
                      </p>

                      <p className="">
                        <b className="d-block">Penalty</b>
                        R40 000 or 2 years
                      </p>
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabFive"
                  aria-expanded="false"
                  aria-controls="blackTabFive"
                >
                  Unlawfully concealing etc nationality of South African ship.
                </button>
              </h2>
              <div
                id="blackTabFive"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                        <b className="d-block">​Description of offence</b>
                        Failing to hoist the National Flag on South African Ship
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Section / Item</b>
                        4(2) read with 52(1) & (2)
                      </p>

                      <p className="mb-3">
                        <b className="d-block">Person(s) liable</b>
                        Master
                      </p>

                      <p className="">
                        <b className="d-block">Penalty</b>
                        R40 000 or 2 years
                      </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShipRegistryOffencesTab;